import React from "react";
import Reveal from "./Reveal";
import AppStoreButtons from "./AppStoreButtons";

const FinalCTA = () => {
  return (
    <section className="final-cta-section" id="waitlist">
      <div className="container">
        <Reveal className="cta-content" variant="up-lg">
          <h2 className="cta-headline">Start Training Today</h2>
          <p className="cta-subheadline">
            Download Thryvin' and let your AI coach build a plan around you.
            Available on iPhone and Android.
          </p>

          <AppStoreButtons />
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
